"use no memo";

import { type ReactNode } from "react";
import { useLocation } from "react-router";

import AdminHeader from "@/src/components/organisms/Header/AdminHeader";
import ConsumerHeader from "@/src/components/organisms/Header/ConsumerHeader";
import DealerHeader from "@/src/components/organisms/Header/DealerHeader";

const Header = () => {
  const location = useLocation();
  let USAGE_MODE: "dealer" | "admin" | "consumer";
  if (location.pathname.startsWith("/dealer")) {
    USAGE_MODE = "dealer";
  } else if (location.pathname.startsWith("/admin")) {
    USAGE_MODE = "admin";
  } else {
    USAGE_MODE = "consumer";
  }
  let headerContent: ReactNode | null = null;
  if (USAGE_MODE === "admin") {
    headerContent = <AdminHeader />;
  } else if (USAGE_MODE === "dealer") {
    headerContent = <DealerHeader />;
  } else {
    headerContent = <ConsumerHeader />;
  }
  return headerContent;
};

export default Header;
